import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import LogoMark from "@/components/LogoMark";

export default function LegalPage({ title, testid, children }) {
  const stand = new Date().toLocaleDateString("de-DE", { month: "long", year: "numeric" });

  return (
    <div className="min-h-screen bg-wine text-cream">
      <header className="border-b border-gold/10 bg-wine/80 backdrop-blur-xl">
        <div className="mx-auto flex max-w-3xl items-center justify-between px-5 py-4">
          <Link to="/" data-testid="legal-logo" className="flex items-center gap-3">
            <LogoMark className="h-9 w-9" />
            <span className="leading-none">
              <span className="block font-serif text-2xl tracking-tight">
                APSARA<span className="text-gold">.</span>
              </span>
              <span className="mt-1 block text-[0.55rem] font-light uppercase tracking-[0.4em] text-gold/90">
                Kollektion
              </span>
            </span>
          </Link>
          <Link
            to="/"
            data-testid="legal-back"
            className="flex items-center gap-2 text-xs font-light uppercase tracking-[0.25em] text-cream/60 transition-colors duration-300 hover:text-gold"
          >
            <ArrowLeft className="h-4 w-4" /> Zurück
          </Link>
        </div>
      </header>

      <main className="mx-auto max-w-3xl px-5 py-12 md:py-16" data-testid={testid}>
        <h1 className="font-serif text-4xl font-light tracking-[-0.02em] md:text-5xl">{title}</h1>
        <div className="mt-8 space-y-4 text-sm font-light leading-relaxed text-rosy [&_a]:text-gold [&_h2]:mb-1 [&_h2]:mt-8 [&_h2]:font-serif [&_h2]:text-2xl [&_h2]:font-light [&_h2]:text-cream [&_h2:first-child]:mt-0 [&_p]:mt-2 [&_strong]:text-cream">
          {children}
        </div>
        <p className="mt-12 text-xs font-light uppercase tracking-[0.2em] text-cream/40">
          Stand: {stand}
        </p>
      </main>
    </div>
  );
}
